import { get } from "./request";
import request from "./request";

/**
 * 使用统计接口（API 文档第 8 节 /console/usage）。
 */

// ---------- 类型 ----------

/** GET /usage/stats 单项 */
export interface UsageStat {
  date: string;
  api_code: string;
  calls: number;
  success_count: number;
  failed_count: number;
  avg_latency_ms: number;
  cost_cents: number;
}

export interface UsageQuery {
  /** 起始（ISO date 或 instant），默认后端取 7 天前 */
  from?: string;
  /** 截止（ISO date 或 instant），默认后端取今天 */
  to?: string;
  /** 筛选特定 API（api_code） */
  endpoint?: string;
}

// ---------- 接口 ----------

export function getUsageStats(query: UsageQuery = {}): Promise<UsageStat[]> {
  const params: Record<string, string> = {};
  if (query.from) params.from = query.from;
  if (query.to) params.to = query.to;
  if (query.endpoint) params.endpoint = query.endpoint;
  return get<UsageStat[]>("/usage/stats", { params });
}

/**
 * GET /usage/export：导出使用统计 CSV。
 * from/to 为 ISO date 或 instant。返回 Blob 供前端触发下载。
 */
export async function exportUsageCsv(params: {
  from?: string;
  to?: string;
} = {}): Promise<Blob> {
  const res = await request.get("/usage/export", {
    params,
    responseType: "blob",
  });
  return res as unknown as Blob;
}
